import { OutgoingPublishRequest } from "../messages/methods/publish";
import { OutgoingRequestDelegate } from "../messages/outgoing-request";
import { OutgoingRequestMessage } from "../messages/outgoing-request-message";
import { NonInviteClientTransaction } from "../transactions/non-invite-client-transaction";
import { UserAgentCore } from "../user-agent-core/user-agent-core";
import { UserAgentClient } from "./user-agent-client";

/**
 * PUBLISH UAC.
 * @public
 */
export class PublishUserAgentClient extends UserAgentClient implements OutgoingPublishRequest {
  constructor(core: UserAgentCore, message: OutgoingRequestMessage, delegate?: OutgoingRequestDelegate) {
    super(NonInviteClientTransaction, core, message, delegate);
  }
}
